module.exports = {"440106001":"五山街道","440106002":"员村街道","440106003":"车陂街道","440106004":"沙河街道","440106006":"石牌街道","440106007":"沙东街道","440106008":"天河南街道","440106009":"林和街道","440106010":"兴华街道","440106011":"棠下街道","440106012":"天园街道","440106013":"猎德街道","440106014":"冼村街道","440106015":"元岗街道","440106016":"黄村街道","440106017":"长兴街道","440106018":"龙洞街道","440106019":"凤凰街道","440106020":"前进街道","440106021":"珠吉街道","440106022":"新塘街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440106.json
// module id = 1948
// module chunks = 0